module.exports = __webpack_public_path__ + "static/media/ba48202e-b3fb-4d2e-b782-6e50f7f710b9.02f56353.eot";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/ba48202e-b3fb-4d2e-b782-6e50f7f710b9.eot
// module id = 78
// module chunks = 0